import React, { useEffect, useState, useRef } from 'react'
import {Form, Input, DatePicker, Card, message} from 'antd'
import { EyeTwoTone, EyeInvisibleOutlined, CheckOutlined } from '@ant-design/icons';
import axios from 'axios';
import { connect } from 'react-redux';

function Profile(props){
  const [messageApi, contextHolder] = message.useMessage();
  const userData = props.user
  const [dataSource, setDataSource] = useState({})
  const ref = useRef(null);

  const handleCheckClick = () => {
    ref.current.validateFields().then(value=>{
      let data = {...value}
      data.id =userData.id
      data.enable = userData.enable

      axios.patch(`/api/user/${data.id}`,data)
      .then(res=>{
        success('使中者編輯成功')
      }).catch(err=>{
        if(typeof err.response.data.errors === 'object' ){
          let error_meaage = Object.values(err.response.data.errors).join(' ')
          error(error_meaage)
        }else{
          error('錯誤，請洽管理員')
          console.error(err)
        }
      })

    })

  }
  useEffect(()=>{
    axios.get(`/api/user/${userData.id}`).then(res=>{
      ref.current.setFieldsValue(res.data)
    }).catch(err=>{
      console.error(err)
    })
  },[])

  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };

  return (
    <div>
      {contextHolder}
      <Card title="編輯個人資料" style={{ maxWidth: '95%', margin: '0 auto' }}
        actions={[
          <CheckOutlined style={{ color:'green' }} key="checked" onClick={handleCheckClick}/>
        ]}>
        <Form
            layout="vertical"
            ref={ref}
        >
          <Form.Item
            name="employee_id"
            label="員工編號"
          >
            <Input disabled/>
          </Form.Item>
          <Form.Item
            name="chinese_name"
            label="中文姓名"
          >
            <Input disabled/>
          </Form.Item>
          <Form.Item
            name="name"
            label="英文姓名(登入帳號)"
          >
            <Input disabled/>
          </Form.Item>
          <Form.Item
            name="email"
            label="電子郵件"
          >
            <Input disabled/>
          </Form.Item>
          <Form.Item
            name="password"
            label="密碼"
            rules={[{
              required: false,
              message: '密碼必須5個字元(含)以上',
              min: 5,
            }]}
          >
            <Input.Password
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
            />
          </Form.Item>
          <Form.Item
            name="date_of_employment"
            label="到職日期"
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
          name="group_permission_id"
          label="請選擇群組權限"
        >
          <Input disabled/>
        </Form.Item>
        <Form.Item
          name="date_of_resignation"
          label="離職日期"
        >
          <Input disabled/>
        </Form.Item>
        </Form>
      </Card>
    </div>
  )
}

const mapStateToProps = ({userProfileReducer: {user}}) => ({
  user
})

export default connect(mapStateToProps)(Profile)
